const ROUTES = {
  USER_ROUTES: {
    HOME: "/user/",
    MY_ORDERS: "/user/seus-pedidos",
    NEW_ORDER: "/user/novo-pedido",
    NEW_ORDER_OLD: "/user/novo-pedido/antigo",
    SIMULATE_ORDER: "/user/simular-pedido",
    EDIT_ORDER: "/user/editar-pedido",
    ORDER_PLACED: "/user/pedido-realizado",
    APPOINTMENT_TITLE: "/user/titulos",
    APPOINTMENT_INVOICES: "/user/notas-fiscais",
    APPOINTMENT_PRICE: "/user/preco",
    HANDOUTS: "/user/comunicados",
    RECLAMATION: "/user/criar-reclamacao",
    RECLAMATION_CONSULT: "/user/fale-conosco",
    RECLAMATION_DETAILS: "/user/detalhes-da-reclamacao/",
    DASH_POSH: "/user/dashboard-posh",
    INSTANT_REWARD: "/user/premios-entregues",
    EMPLOYEE: "/user/funcionarios",
    SALES: "/user/vendas",
    PERFORMANCE_MANAGEMENT: "/user/gestao-de-desempenho",
    NOZZLE: "/user/bico-e-produto",
    GOALS_AND_COMMISSIONS: "/user/metas-e-comissoes",
    PEAK_TIME_HISTORY: "/user/horario-de-pico",
    COMMISSION_CALCULATOR: "/user/calculadora-de-comissao",
    NOTFOUND: "/user/not-found",
    ROADLOAD: "/user/agenda-e-vem",
    DISCOUNT: "/user/descontos/home",
    PRODUCT: "/user/descontos/produtos",
    NEW_PROGRAMMING: "/user/programacao/criar",
    EDIT_PROGRAMMING: "/user/programacao/editar/",
    MY_DRIVERS: "/user/meus-motoristas",
  },
  ADMIN_ROUTES: {
    HOME: "/admin/",
    NEW_USER: "/admin/criar-usuario",
    EDIT_USER: "/admin/editar-usuario",
    LIST_USERS: "/admin/usuarios",
    ALL_COMMUNICATION: "/admin/comunicados",
    HANDOUTS: "/admin/comunicados",
    LIST_INVOICES_IMAGES: "/admin/comprovantes",
    PRODUCT_BLOCK: "/admin/bloqueio-de-produtos",
    RECLAMATION_ANALYSIS: "/admin/registro-de-atendimento",
    RECLAMATION_DETAILS_ADM: "/admin/detalhes-da-reclamacao/",
    NOZZLE: "/admin/bico-e-produto",
    DRIVER_AND_CUSTOMER: "/admin/motorista-e-cliente",
    NOTIFICATIONS: {
      ROOT: "/admin/notificacoes",
      CREATE: "/admin/notificacoes/criar",
      EDIT: "/admin/notificacoes/editar",
      VIEW: "/admin/notificacoes/visualizar",
    },
  },
};

export default ROUTES;
